import SyncSettingsTab from './syncSettingsTab.view';

export default SyncSettingsTab;
